import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '../shared/shared.module';
import {BsDatepickerModule} from 'ngx-bootstrap/datepicker';
import { OwlDateTimeModule, OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import {OwlMomentDateTimeModule} from 'ng-pick-datetime-moment';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import {ReportingService} from './services/reporting.service';
import {CallsComponent} from './components/calls/calls.component';

export const MY_MOMENT_FORMATS = {
    parseInput: 'l LT',
    fullPickerInput: 'YYYY-MM-DD HH:mm:ss',
    datePickerInput: 'l',
    timePickerInput: 'LT',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
};

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        BsDatepickerModule.forRoot(),
        NgxDatatableModule,
        NguiAutoCompleteModule,
        OwlDateTimeModule,
        OwlMomentDateTimeModule,
        BrowserAnimationsModule
    ],
    providers: [
        ReportingService,
        {provide: OWL_DATE_TIME_FORMATS, useValue: MY_MOMENT_FORMATS}
    ],
    declarations: [CallsComponent]
})
export class ReportingModule { }


// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/reporting/reporting.module.ts